/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';
import { Styles } from './Styles';

type Props = {
  /**
   * The color variant of the label.
   * @default 'gray'
   * */
  color?:
    | 'gray'
    | 'white'
    | 'info'
    | 'success'
    | 'warning'
    | 'error'
    | 'peach'
    | 'neutral300'
    | 'bolt'
    | 'cream'
    | 'success500';
  /**
   * Content to render inside the label. Generally this is plain text,
   * but other content such as icons or Avatars may also be rendered.
   */
  children: React.ReactNode;
  /**
   * The size of `TagLabel`.
   * @default 'medium'
   */
  size?: 'small' | 'medium';
};

const defaultProps = {
  color: 'gray',
  size: 'medium',
};

/**
 * Renders a tag-like component.
 */
export const TagLabel = (_props: Props) => {
  const props = {
    ...defaultProps,
    ..._props,
  };
  return (
    <span css={Styles.root} data-color={props.color} data-size={props.size}>
      {props.children}
    </span>
  );
};
